const ENDPOINT = process.env.REACT_APP_ENDPOINT
export const API_ENDPOINT = `${ENDPOINT}api`
export const AUTH_ENDPOINT = `${ENDPOINT}auth`
